import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Lopetettu",
  "Spare part list": "Varaosaluettelo",
  "Download Excel": "Lataa Excel",
  "Recent search list": "Viimeisimpien hakujen luettelo",
  "No data": "Ei tietoja",
  "spare part": "varaosa",
  "none": "ei ole",
  "no value": "ei arvoa",
  "No results found": "Tuloksia ei löytynyt",
  "Spare parts for": "Varaosat seuraavia varten",
  "Could not load cumulated data": "Kumuloituja tietoja ei voitu ladata",
  "commissioning part": "käyttöönotto-osa",
  "wear part": "kulutusosa",
  "Search": "Etsi",
  "Tk": "Tk",
  "Spare part number": "Varaosan numero",
  "drawing": "piirustus",
  "Products for": "Tuotteet",
  "Available": "Saatavilla",
  "MM": "MM",
  "The entered order code is invalid": "Syötetty tilauskoodi on virheellinen",
  "Recommended": "Suositeltu",
  "No data available for the entered search parameters": "Syötetyille hakuparametreille ei ole saatavilla tietoja",
  "Search spare parts": "Etsi varaosia",
  "Order code / product root / serial number": "Tilauskoodi/tuotteen juuri/sarjanumero",
  "Characteristic": "Ominaisuus",
  "Please enter an order code": "Anna tilauskoodi",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "Laatu- ja turvallisuusnäkökohtien osalta Endress+Hauser suosittelee vahvasti, että käytetään ainoastaan aitoja Endress+Hauser-varaosia. \nLaitetta saa huoltaa ja korjata vain pätevä henkilökunta. \nLaiteasiakirjoja koskevia standardeja ja lakisääteisiä vaatimuksia sekä mahdollisia todistuksia on noudatettava!",
  "Maintenance advice": "Huolto-ohjeet",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Mihin tuotteeseen (tuotteisiin) varaosaani voidaan käyttää? Varaosan tilauskoodin (esim. 71002865 tai XPD0024) täyttäminen osoittaa, missä laitteissa kyseistä varaosaa voidaan käyttää.",
  "tool": "työkalu",
  "Production numbers": "Tuotantoluvut",
  "New alternative": "Uusi vaihtoehto",
  "There are no items selected. Please use the checkboxes to make your selection": "Kohteita ei ole valittu. Käytä valintaruutuja tehdessäsi valintasi.",
  "Service segmentation": "Palvelun segmentointi",
  "Seg": "Seg",
  "Valid": "Voimassa",
  "Pos": "Pos",
  "Value": "Arvo",
  "service segmentation 2": "Perustietoja edellyttävät osat. Edellytyksenä on menestyksekäs osallistuminen E+H-peruskoulutukseen.",
  "Phase out date": "Vaiheen päättymispäivä",
  "service segmentation 1": "Perustietoja edellyttävät osat.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Mitä varaosia tuotteeseeni on saatavilla? Täyttämällä tilauskoodi (esim. FTC260-AA2A1 tai PMC51-BA21JB1CGBTDJB) tai tuotetunnus (esim. FTC260 tai 83F50) saat näkyviin tarvittavat varaosat.",
  "Set filter": "Aseta suodatin",
  "Search date": "Hakupäivä",
  "Group": "Ryhmä",
  "Warning": "Varoitus",
  "Description": "Kuvaus",
  "Cancel": "Peruuta",
  "service segmentation 4": "Osat tehtaalla tapahtuvaa korjausta varten. Asiantuntijatietämys on pakollista.",
  "service segmentation 3": "Osat, jotka edellyttävät erityisosaamista. Edellytyksenä on menestyksekäs osallistuminen E+H-koulutukseen.",
  "Drawing Position Number": "Piirustuksen sijainnin numero",
  "Spare parts search": "Varaosien haku",
  "Confirm": "Vahvista",
  "Ordercode too short": "Tilauskoodi liian lyhyt",
  "Product status": "Tuotteen tila",
  "Open": "Avaa",
  "Clear": "Kirkas",
  "PDF file with assembly instructions": "PDF-tiedosto, jossa on kokoonpano-ohjeet",
  "Search products": "Etsi tuotteita",
  "Export": "Vie",
  "Production date": "Tuotantopäivä",
  "Order stop": "Tilaus pysähtyy",
  "Calibration until": "Kalibrointi kunnes",
  "PDF file with compatibility information": "PDF-tiedosto, jossa on yhteensopivuustietoja",
  "Add selection to cart": "Lisää valinta ostoskoriin",
  "Mounting advices": "Asennusneuvoja",
  "Recommended parts only": "Vain suositellut osat",
  "not applicable": "ei sovellettavissa",
  "accessories": "tarvikkeet",
  "Cumulative spare parts list": "Kumulatiivinen varaosaluettelo",
  "YYYY": "YYYY",
  "Title": "Otsikko",
  "Error": "Virhe",
  "Ordercode too long": "Tilauskoodi liian pitkä",
  "Functions": "Toiminnot",
  "Rec": "Rec",
  "Type": "Tyyppi",
  "Spare sensor until": "Vara-anturi kunnes",
  "Spare parts until": "Varaosat, kunnes",
  "Filter": "Suodatin",
  "Check all": "Tarkista kaikki",
  "Order code": "Tilauskoodi",
  "Repair until": "Korjaa kunnes",
  "Tag": "Tag",
  "Ok": "Ok",
  "Category code": "Luokan koodi",
  "Phase out": "Vaiheittain",
  'Compatibility advices': 'Lisädokumentit',
  'Co.': 'Lisä dok.',
} as LocalizedDictionary;
